import React from 'react';
import { states } from '@/constants/lifecycle';
import DropdownItem from '@/components/DropdownItem';
import ToolsMenu from '@/components/tools/ToolsMenu';
import events from '../hooks/events';
import selectors from '../hooks/selectors';

const VocabularyTools = ({
  category,
  vocabulary,
  upward,
  listItem = false,
}) => {
  const { allowUpdate } = selectors.useVocabularyTools();
  const show = events.useShowSaveVocabulary(category, vocabulary);
  const reset = events.useResetVocabulary(category, vocabulary);

  return (
    <ToolsMenu listItem={listItem} upward={upward}>
      {allowUpdate && (
        <>
          <DropdownItem
            disabled={vocabulary.updateStatus === states.PENDING}
            icon="share"
            onClick={show}
            textId="actions.open"
          />
          <DropdownItem
            disabled={vocabulary.updateStatus === states.PENDING}
            icon="undo"
            onClick={reset}
            textId="actions.reset"
          />
        </>
      )}
    </ToolsMenu>
  );
};

export default VocabularyTools;
